(function() {
'use strict';

angular
    .module('transfers')
    .controller('TransferAirports', TransferAirports);

function TransferAirports(
    searchUnitService,
    destinationService,
    $location,
    $route
) {
    const cm = this;

    cm.setDestinationAirport = setDestinationAirport;
    cm.setDestinations = setDestinations;

    searchUnitService.getAirports().then(function(airports) {
        cm.airports = airports;
    });

    function setDestinationAirport(airport) {
        searchUnitService.setDestinationAirport(airport, $route.current.area === 'transfers');
        $location.path($route.current.area);
    }

    function setDestinations(airport) {
        if (TRPCONFIG.Domain.HotelsOnFlightsEnabled) {
            destinationService.getDetails(airport).then(destination => {
                searchUnitService.setDestination(destination);
                setDestinationAirport(destination);
            });
        } else {
            setDestinationAirport(airport);
        }
    }
}
})();
